import { Routes } from '@angular/router'
import { authGuard } from '../shared/guards/permission.guard'
import { PermissionsEnum } from '../shared/models/permission-based-access.model'


const qcrReportPermissions = [
  PermissionsEnum.QCR_ANALYSIS_VIEW,
  PermissionsEnum.QCR_STAT_VARIANCE_VIEW,
  PermissionsEnum.QCR_CONTROLABLES_VIEW,
  PermissionsEnum.QCR_BASE_COST_VIEW,
  PermissionsEnum.QCR_MARGINAL_CONTRIB_VIEW,
]

export const qcrRoutes: Routes = [
  {
    path: 'report',
    canActivate: [authGuard],
    data: {
      breadcrumb: 'routes.qcr.reports.title',
      permissionsNeeded: qcrReportPermissions,
    },
    children: [
      {
        path: 'qcr-analysis',
        canActivate: [authGuard],
        data: {
          breadcrumb: 'routes.qcr.reports.qcrAnalysis',
          permissionsNeeded: [PermissionsEnum.QCR_ANALYSIS_VIEW],
        },
        loadComponent: () => import('./pages/reports/qcr-analysis/qcr-analysis.component'),
      },
      {
        path: 'stat-variance',
        canActivate: [authGuard],
        data: {
          breadcrumb: 'routes.qcr.reports.statVariance',
          altTitle: 'qcr.reports.statVariance.title',
          permissionsNeeded: [PermissionsEnum.QCR_STAT_VARIANCE_VIEW],
        },
        loadComponent: () => import('./pages/reports/stat-variance/stat-variance.component'),
      },
      {
        path: 'controlables-qcr',
        canActivate: [authGuard],
        data: {
          breadcrumb: 'routes.qcr.reports.controlablesQcr',
          altTitle: 'qcr.reports.controlablesQcr.title',
          permissionsNeeded: [PermissionsEnum.QCR_CONTROLABLES_VIEW],
        },
        loadComponent: () => import('./pages/reports/controlables-qcr/controlables-qcr.component'),
      },
      {
        path: 'base-cost',
        canActivate: [authGuard],
        data: {
          breadcrumb: 'routes.qcr.reports.baseCost',
          permissionsNeeded: [PermissionsEnum.QCR_BASE_COST_VIEW],
        },
        loadComponent: () => import('./pages/reports/base-cost/base-cost.component'),
      },
      {
        path: 'marginal-contribution-analysis',
        canActivate: [authGuard],
        data: {
          breadcrumb: 'routes.qcr.reports.marginalContribution',
          altTitle: 'qcr.reports.marginalContribution.title',
          permissionsNeeded: [PermissionsEnum.QCR_MARGINAL_CONTRIB_VIEW],
        },
        loadComponent: () => import('./pages/reports/marginal-contribution-analysis/marginal-contribution-analysis.component'),
      },
    ],
  },
]
